import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-xl border border-gray-200 bg-white p-5 text-left shadow-sm" }
const _hoisted_2 = { class: "flex items-center justify-between gap-2" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "inline-flex w-fit items-center rounded-md bg-primary5 px-2 py-0.5 text-sm font-bold text-primary" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["datetime"]
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-sm text-gray-600"
}
const _hoisted_8 = { class: "mt-4 flex flex-col gap-4" }
const _hoisted_9 = ["d"]
const _hoisted_10 = { class: "flex flex-col gap-0.5 pt-0.5" }
const _hoisted_11 = { class: "text-sm font-semibold leading-snug text-textPrimary" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm leading-relaxed text-gray-600"
}

import { computed } from 'vue'

import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import { CHANGELOG_ITEM_META } from '@/config/changelog'
import type { ChangelogEntry, ChangelogItemType } from '@/config/changelog'
import { parseLocalDate } from '@/utils/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangelogEntry',
  props: {
    entry: {}
  },
  setup(__props: any) {

const props = __props;



// Classes por categoria (Tailwind estatico — nao pode ser interpolado dinamicamente).
const ITEM_STYLES: Record<ChangelogItemType, { wrap: string; icon: string; label: string }> = {
  feature: { wrap: 'bg-green-50', icon: 'text-sucess', label: 'text-sucess' },
  improvement: { wrap: 'bg-primary5', icon: 'text-primary', label: 'text-primary' },
  fix: { wrap: 'bg-orange-50', icon: 'text-alert', label: 'text-alert' }
}

const formattedDate = computed(() => {
  const date = parseLocalDate(props.entry.date)
  if (!date) return props.entry.date
  return format(date, "dd 'de' MMM. 'de' yyyy", { locale: ptBR })
})

const compareUrl = computed(() => {
  if (!props.entry.range) return ''
  return `https://github.com/bng-health/minhaescala_web/compare/${props.entry.range}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, " v" + _toDisplayString(_ctx.entry.version), 1),
        (_ctx.entry.range)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: compareUrl.value,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-[10px] text-gray-400 transition hover:text-gray-600 hover:underline",
              title: "Ver mudanças no GitHub"
            }, " (" + _toDisplayString(_ctx.entry.range) + ") ", 9, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("time", {
        datetime: _ctx.entry.date,
        class: "text-xs font-medium uppercase tracking-wide text-gray-400"
      }, _toDisplayString(formattedDate.value), 9, _hoisted_6)
    ]),
    (_ctx.entry.summary)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.entry.summary), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entry.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "flex gap-3"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["flex h-8 w-8 shrink-0 items-center justify-center rounded-full", ITEM_STYLES[item.type].wrap])
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["h-4 w-4", ITEM_STYLES[item.type].icon]),
              fill: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                d: _unref(CHANGELOG_ITEM_META)[item.type].icon
              }, null, 8, _hoisted_9)
            ], 2))
          ], 2),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              class: _normalizeClass(["text-[11px] font-semibold uppercase tracking-wide", ITEM_STYLES[item.type].label])
            }, _toDisplayString(_unref(CHANGELOG_ITEM_META)[item.type].label), 3),
            _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1),
            (item.description)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.description), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})